// Keeps every out-of-stock card below every in-stock card in the live grid,
// even once items have arrived from several different "load more" fetches
// (each fetch is only sorted within itself server-side — see the comment
// above the product loop in sections/sale-collection.liquid).
function insertRespectingAvailability(grid, item) {
  if (item.dataset.available === 'false') {
    grid.appendChild(item);
    return;
  }
  var firstSoldOut = grid.querySelector('.grid__item[data-available="false"]');
  if (firstSoldOut) {
    grid.insertBefore(item, firstSoldOut);
  } else {
    grid.appendChild(item);
  }
}

// Scrolls so the first newly-loaded product lands near the top of the
// viewport, instead of leaving the page anchored at the load-more button.
function scrollToNewProducts(item) {
  if (!item) return;
  var header = document.querySelector('header');
  var headerOffset = header ? header.offsetHeight : 0;
  var offsetTop = item.getBoundingClientRect().top + window.pageYOffset - headerOffset - 10;

  window.scrollTo({
    top: offsetTop,
    behavior: 'smooth'
  });
}

document.addEventListener('click', function (event) {
  var button = event.target.closest('.sale-collection-load-more__button');
  if (!button) return;

  var container = button.closest('.sale-collection-load-more');
  var section = container.closest('.sale-collection');
  var grid = section.querySelector('.sale-collection-grid');
  if (!container || !section || !grid) return;

  var pageSize = Number(container.dataset.pageSize) || 12;
  var templates = section.querySelectorAll('template.sale-collection-overflow-item');

  if (templates.length > 0) {
    var toReveal = Math.min(pageSize, templates.length);
    var firstRevealed = null;
    for (var i = 0; i < toReveal; i++) {
      var revealed = templates[i].content.firstElementChild;
      insertRespectingAvailability(grid, revealed);
      templates[i].remove();
      if (!firstRevealed) firstRevealed = revealed;
    }

    var stillHasOverflow = templates.length > toReveal;
    if (!stillHasOverflow && container.dataset.hasMorePages !== 'true') {
      container.remove();
    }
    scrollToNewProducts(firstRevealed);
    return;
  }

  var sectionId = container.dataset.sectionId;
  var nextPage = Number(container.dataset.currentPage) + 1;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  var url = new URL(window.location.href);
  url.searchParams.set('page', nextPage);
  url.searchParams.set('section_id', sectionId);

  fetch(url.toString())
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = parsed.querySelector('.sale-collection-grid');
      var firstNewItem = null;
      if (newGrid) {
        var newItems = newGrid.querySelectorAll('.grid__item');
        for (var j = 0; j < newItems.length; j++) {
          insertRespectingAvailability(grid, newItems[j]);
          if (!firstNewItem) firstNewItem = newItems[j];
        }
      }
      scrollToNewProducts(firstNewItem);

      var newLoadMore = parsed.querySelector('.sale-collection-load-more');
      if (newLoadMore) {
        container.dataset.currentPage = nextPage;
        container.dataset.hasMorePages = newLoadMore.dataset.hasMorePages;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      } else {
        container.remove();
      }
    })
    .catch(function (error) {
      console.error('Sale collection load more failed:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
});
